(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loop-product"] && !Shopify.designMode) return;
  try {
    
function initLoopProduct(){
 const root=document.querySelector('.lp-root');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('.lp-form');if(form)form.addEventListener('submit',e=>e.preventDefault());
 const track=root.querySelector('.lp-images'),slides=[...root.querySelectorAll('.lp-slide')],thumbs=[...root.querySelectorAll('.lp-thumb')],prev=root.querySelector('[data-gallery-prev]'),next=root.querySelector('[data-gallery-next]'),count=root.querySelector('[data-gallery-count]');
 let galleryIndex=0;
 function syncGallery(){galleryIndex=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));thumbs.forEach((t,i)=>{t.classList.toggle('active',i===galleryIndex);t.setAttribute('aria-pressed',String(i===galleryIndex));});if(count)count.textContent=(galleryIndex+1)+' / '+slides.length;if(prev)prev.disabled=galleryIndex===0;if(next)next.disabled=galleryIndex===slides.length-1;}
 function goGallery(i){i=Math.max(0,Math.min(slides.length-1,i));track.scrollTo({left:i*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
 thumbs.forEach(b=>b.addEventListener('click',()=>goGallery(Number(b.dataset.slide))));
 if(prev)prev.addEventListener('click',()=>goGallery(galleryIndex-1));if(next)next.addEventListener('click',()=>goGallery(galleryIndex+1));
 track.addEventListener('scroll',syncGallery,{passive:true});
 track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();goGallery(galleryIndex+(e.key==='ArrowRight'?1:-1));}});
 let drag=null;
 track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;drag={x:e.clientX,left:track.scrollLeft};track.classList.add('dragging');track.setPointerCapture(e.pointerId);});
 track.addEventListener('pointermove',e=>{if(!drag)return;track.scrollLeft=drag.left+drag.x-e.clientX;});
 function endGalleryDrag(){if(!drag)return;drag=null;track.classList.remove('dragging');goGallery(Math.round(track.scrollLeft/track.clientWidth));}
 track.addEventListener('pointerup',endGalleryDrag);track.addEventListener('pointercancel',endGalleryDrag);track.addEventListener('dragstart',e=>e.preventDefault());
 new ResizeObserver(()=>{track.scrollTo({left:galleryIndex*track.clientWidth,behavior:'instant'});syncGallery();}).observe(track);
 syncGallery();
 root.querySelectorAll('a[href="#loop-buy"]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();document.getElementById('loop-buy').scrollIntoView({behavior:'smooth',block:'center'});}));
 root.querySelectorAll('button[aria-expanded]').forEach(b=>b.addEventListener('click',()=>{const id=b.getAttribute('aria-controls'),panel=id?document.getElementById(id):b.nextElementSibling;if(panel){const open=b.getAttribute('aria-expanded')!=='true';b.setAttribute('aria-expanded',String(open));panel.hidden=!open;panel.style.display=open?'block':'none';}}));
 root.querySelectorAll('[role="list"]').forEach(list=>{if(list.scrollWidth>list.clientWidth){list.style.overflowX='auto';list.style.scrollSnapType='x mandatory';}});
 root.querySelectorAll('[data-tlc-root]').forEach(carousel=>{const track=carousel.querySelector('[data-tlc-track]'),slides=[...carousel.querySelectorAll('[data-tlc-slide]')],steps=[...carousel.querySelectorAll('[data-tlc-step]')];let index=0;function go(i){index=(i+slides.length)%slides.length;track.scrollTo({left:slides[index].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});steps.forEach((b,j)=>{b.setAttribute('aria-current',String(j===index));b.setAttribute('data-done',String(j<=index));});const fill=carousel.querySelector('[data-tlc-fill]');if(fill)fill.style.width=(index/(slides.length-1)*100)+'%';}steps.forEach((b,i)=>b.addEventListener('click',()=>go(i)));carousel.querySelector('[data-tlc-prev]').addEventListener('click',()=>go(index-1));carousel.querySelector('[data-tlc-next]').addEventListener('click',()=>go(index+1));track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}});});
 root.querySelectorAll('.tv-track,.rv-track').forEach(track=>{const section=track.closest('.shopify-section'),dots=[...section.querySelectorAll('.tv-dot,.rv-dot')];track.style.overflowX='auto';dots.forEach((b,i)=>b.addEventListener('click',()=>{const cards=[...track.children];if(cards[i])track.scrollTo({left:cards[i].offsetLeft-cards[0].offsetLeft,behavior:'smooth'});dots.forEach((d,j)=>d.setAttribute('aria-current',String(i===j)));}));section.querySelectorAll('.rv-arrow').forEach(b=>b.addEventListener('click',()=>{track.scrollBy({left:b.getAttribute('aria-label')==='Anterior'?-track.clientWidth:track.clientWidth,behavior:'smooth'});}));});
}
initLoopProduct();document.addEventListener('shopify:section:load',initLoopProduct);

  } catch(e) { console.error(e); }
})();
})();
